import React from 'react'
import { useAuth } from '@/modules/auth/context/AuthContext'
import { Separator } from '@/shared/ui'
import AffiliateInsightsMaster from '@/modules/affiliates/components/AffiliateInsightsMaster'
import AffiliateMonthlySummaryPanel from '@/modules/affiliates/components/AffiliateMonthlySummaryPanel'
import AffiliateUplineChildrenPanel from '@/modules/affiliates/components/AffiliateUplineChildrenPanel'
import { supabase } from '@/lib/supabase'
import AffiliateShareLinks from '../components/AffiliateShareLinks'

export default function DashboardAffiliatePage() {
  const { user, profile } = useAuth()
  const [code, setCode] = React.useState<string>('')

  React.useEffect(() => {
    ;(async () => {
      try {
        if (profile?.id) {
          const r = await supabase
            .from('affiliates')
            .select('code')
            .eq('user_id', profile.id)
            .maybeSingle()
          setCode(r.data?.code || '')
        }
      } catch {}
    })()
  }, [profile?.id])

  return (
    <div className="w-full">
      <div className="mb-2 flex items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-semibold">Dashboard Afiliado</h1>
          <p className="mt-1 text-sm text-foreground/70">Bem-vindo, {profile?.full_name || user?.email}</p>
        </div>
        <AffiliateShareLinks code={code} />
      </div>
      <Separator className="my-6" />
      {profile?.id && (
        <>
          <AffiliateInsightsMaster
            affiliateUserId={profile.id}
            extraBelowCards={
              <AffiliateMonthlySummaryPanel
                affiliateUserId={profile.id}
                showActions={false}
                allowReceiptManage={false}
              />
            }
          />
          <AffiliateUplineChildrenPanel parentAffiliateId={profile.id} />
        </>
      )}
      {/* Card de recebimentos removido do dashboard; acessar via página "Recebíveis" */}
    </div>
  )
}

